var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "help" } }, [
      _c("div", { staticClass: "title" }, [_vm._v("疑难解答")]),
      _c("div", { staticClass: "faq-page" }, [
        _c("p", [
          _vm._v(
            " 1.无法通过Steam注册/登入由于国内限制，用户在使用Steam注册/登入时可能出现无法连接、拒绝访问等问题，用户可通过安装网游加速器加速Steam社区来解决此问题。如仍存在问题，可尝试通过更换浏览器解决。 "
          ),
        ]),
        _c("p", [_c("br")]),
        _c("p", [_vm._v("2.Steam交易连结获取")]),
        _c("p", [_vm._v("2.1 PC端用户")]),
        _c("p", [_vm._v("(1).获取Steam交易地址")]),
        _c("p", [_vm._v("(2).找到第三方网站获取Steam交易连结")]),
        _c("p", [_c("br")]),
        _c("p", [_vm._v("2.2 手机端用户")]),
        _c("p", [_vm._v("(1).下载Steam ")]),
        _c("p", [
          _vm._v(
            " App，登入后，通过流程“您与好友—库存—交易报价—右侧选单按钮—谁能向我发送交易报价”，在最下面即可找到交易连结。  "
          ),
        ]),
        _c("p", [_c("br")]),
        _c("p", [_vm._v("3.充值相关问题")]),
        _c("p", [_vm._v("问题：充值没有到账？")]),
        _c("p", [
          _vm._v(
            " 回答：支付宝/微信支付系统可能会有延迟，超3分钟后仍未到账，请您及时联系网站客服进行处理。  "
          ),
        ]),
        _c("p", [_c("br")]),
        _c("p", [_vm._v("4.饰品取回相关问题")]),
        _c("p", [_vm._v("问题1：为什么提示我饰品无法取回？")]),
        _c("p", [
          _vm._v(
            " 回答：多次尝试取回饰品无法取回可能是帐号交易许可权被限制，请打开连结查找不可交易的原因后再尝试取回, 前往Steam客服页面查询原因PS：如问题仍然存在，可更换一个可用的Steam帐号绑定交易URL取回或联系客服解决。  "
          ),
        ]),
        _c("p", [_vm._v("问题2：Steam未公开")]),
        _c("p", [
          _vm._v(
            " 回答：打开Steam个人资讯，点击编辑个人资料，找到隐私设定，将库存选项调整为公开，并将下面选项框的✓取消。 "
          ),
        ]),
        _c("p", [_vm._v("问题3：饰品存在问题")]),
        _c("p", [
          _vm._v(
            " 回答：这种问题可能是由于发货系统出现问题或商品库存不足造成，建议您再尝试几次取回，如仍有问题，建议将饰品换成余额并在商城挑选心仪的物品。 问题4：取回了好久一直没有发送报价 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 回答：部分饰品采取人工发货途径，所以发货时间相比自动发货可能会有所延迟，我们会在全网为您搜索匹配的饰品，一般在24小时内即可发货，请您耐心等待，如遇发货失败可多尝试几次取回。 "
          ),
        ]),
        _c("p", [
          _vm._v(" PS：注意：报价发出后一小时未接受，系统将会自动取消交易。"),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_vm._v("5.盲盒对战")]),
        _c("p", [_vm._v("问题1：我是否可以取消或更改？")]),
        _c("p", [
          _vm._v(
            "回答：我们并不提供这样的功能，因为这样会极大影响奖池分配概率。"
          ),
        ]),
        _c("p", [
          _vm._v(
            " 问题2：什么是公平性验证？ 回答：在每个回合开始时，服务会生成一个介于0到1间的长乱数（例如0.282796734），并通过SHA-2算灋进行加密。回合结束时，服务会将此数位乘以活动票总数，进而获得最终结果的编号。加密管道和加密码我们会在回合之后公布，保证活动的公平性。 PS：回合结束时，活动为C1000（活动中有100000张票），生成的数位0.282796734。服务将0.282796734乘以100000，进而得到将在抽奖时显示的编号28279。 "
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_vm._v("6.其他问题")]),
        _c("p", [
          _vm._v(
            " 问题1：我如何使用邀请码？ 回答：注册之后，你可以在个人中心--个人资料页面找到填写邀请码。你也可以在分销页面找到自己的分销连结和分销码，分享给你的好友。他们在活动中的充值行为也会为你带来收益。  "
          ),
        ]),
        _c("p", [_vm._v("问题2：饰品的价格依据是什么？")]),
        _c("p", [
          _vm._v(
            " 回答：我们根据Steam市场的价格给每个饰品估价，饰品估价在全平台都是一致的。盲盒奖励的饰品，您也可以选择直接兑换为余额。 "
          ),
        ]),
        _c("p", [_c("br")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }